import {BaseViewModel} from "../../../infrastructure/models/base-view-model";

export class PreviousMeetingsWidgetStatisticsViewModel extends BaseViewModel {
  homeWins: Number;
  awayWins: Number;
  draws: Number;

  constructor(homeWins: Number = 0, awayWins: Number = 0, draws: Number = 0) {
    super();

    this.homeWins = homeWins;
    this.awayWins = awayWins;
    this.draws = draws;
  }
}
